import { render, staticRenderFns } from "./RankChangeFinish.vue?vue&type=template&id=2dd4f396&"
import script from "./RankChangeFinish.vue?vue&type=script&lang=js&"
export * from "./RankChangeFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports